// Segment 8 — Show & Tell
// Timer chip is set to 2:30 per-org in SessionPage (preset = 150s)
const FORMAT = [
  'Show the thing',
  'Name the hours it saves',
  'One thing you learned',
];

const Segment8 = () => (
  <div>
    <h1 className="text-4xl md:text-5xl font-bold text-ink mb-10 leading-tight">Show & Tell</h1>

    {/* Format card */}
    <div
      className="bg-ink rounded-3xl p-10 md:p-12 max-w-lg mb-8"
      data-testid="show-tell-format-card"
    >
      <p className="text-white/50 text-sm font-bold uppercase tracking-widest mb-7">
        6 organizations × 2.5 minutes
      </p>
      <div className="space-y-5">
        {FORMAT.map((point, i) => (
          <div key={i} className="flex items-start gap-4">
            <span className="text-brand-orange font-mono font-bold text-xl mt-0.5 shrink-0 w-6">
              {i + 1}
            </span>
            <p className="text-white text-xl md:text-2xl font-semibold leading-snug">{point}</p>
          </div>
        ))}
      </div>
    </div>

    <p className="text-sm text-ink-secondary">
      Use the timer above — reset it after each organization.
    </p>
  </div>
);

export default Segment8;
